import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Start from './component/Start'
import './App.css'
import Home from './component/Home'
import Illust from './component/Illust'
import Message from './component/Message'
import TimeLine from './component/TimeLine'
import Hokuro from './component/Hokuro'
import Background from './component/parts/Background'

function App() {
  return (
    <div className=" h-full">
      <Background />
      <BrowserRouter>
        <Routes>
          <Route path="/nemo2024/" element={<Start />} />
          <Route path="/nemo2024/home" element={<Home />} />
          <Route path="/nemo2024/illust" element={<Illust />} />
          <Route path="/nemo2024/message" element={<Message />} />
          <Route path="/nemo2024/event" element={<TimeLine />} />
          <Route path="/nemo2024/hokuro" element={<Hokuro />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
